// extracted by mini-css-extract-plugin
module.exports = {"noEdit":"antd-pro-components-no-edit-index-noEdit"};